import React from 'react'
import { styled } from '@mui/system'
import { CardHeader, Grid, Typography } from '@mui/material'
import { generateUtilityClasses } from '@mui/material'
import DropdownFieldSearch from '../../../../../../ui/DropdownFieldSearch'
import { TextField } from '../../../../../../ui'

const classes = generateUtilityClasses('Grid', ['root', 'row'])

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`&.${classes.root}`]: {},
  [`& .${classes.row}`]: {
    margin: theme.spacing(1, 0, 2, 0),
  },
}))

const SettingsForm = () => {
  return (
    <>
      <CardHeader title='Settings' />
      <Grid container spacing={2} px={3} pt={3}>
        <Grid item xs={12} sm={6}>
          <DropdownFieldSearch
            name='IsCPI'
            label='Is CPI'
            options={[
              { key: true, value: 'Yes' },
              { key: false, value: 'No' },
            ]}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField multiline name='Comments' label='Comments' fullWidth />
        </Grid>
        <Grid item xs={12} sm={6}>
          <DropdownFieldSearch
            name='IsActive'
            label='Is Active?'
            options={[
              { key: true, value: 'Yes' },
              { key: false, value: 'No' },
            ]}
            fullWidth
          />
        </Grid>
      </Grid>
    </>
  )
}

export default SettingsForm
